import React from 'react';
import TwilioImg from 'assets/logos/twilio.png';
import AfricastalkingImg from 'assets/logos/africastalking.png';
import CloudflareImg from 'assets/logos/cloudflare.png';
import FlutterwaveImg from 'assets/logos/flutterwave.png';
import OdooImg from 'assets/logos/odoo.png';
import SendgridImg from 'assets/logos/sendgrid.png';
import StripeImg from 'assets/logos/stripe.png';
import ZengapayImg from 'assets/logos/zengapay.png';

const integrations = [
  { name: 'Twilio', logo: TwilioImg },
  { name: "Africa's Talking", logo: AfricastalkingImg },
  { name: 'SendGrid', logo: SendgridImg },
  { name: 'Flutterwave', logo: FlutterwaveImg },
  { name: 'Stripe', logo: StripeImg },
  { name: 'Odoo', logo: OdooImg },
  { name: 'ZengaPay', logo: ZengapayImg },
  { name: 'Cloudflare', logo: CloudflareImg },
];

export const Integrations = () => {
  return (
    <section className="py-28 bg-white">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-10 items-center justify-items-center">
          {integrations.map((i) => (
            <div
              key={i.name}
              className="transition duration-300 ease-in-out hover:filter-none filter grayscale"
            >
              <img
                src={i.logo}
                alt={i.name}
                className="h-16 w-auto object-contain transition duration-300 ease-in-out"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
